import { CrudStore } from 'core/types/crudStore'

export const getCompetitorSource = () => {
  const source = CrudStore.get('Dropdowns', 'Competitors')

  source.setRoot('Competitors')

  return source
}
